import * as React from 'react';
import { Button } from '@sheinc/shelikes-design-system';
import './understandingCheck.module.scss';

type Props = {
  lessonIndex: number;
  sectionIndex: number;
  sectionTitle: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onNextClick: () => any;
};

export class UnderstandingCheck extends React.Component<Props> {
  render() {
    const { lessonIndex, sectionIndex, sectionTitle, onNextClick } = this.props;
    return (
      <div styleName="understanding-check">
        <div styleName="text">理解したら次に進もう</div>
        <div styleName="section-title">
          LESSON {lessonIndex + 1}. {String(sectionIndex + 1).padStart(2, '0')} {sectionTitle}
        </div>
        <div styleName="button-wrapper">
          <Button variant="primary" onClick={onNextClick} fullWidth>
            {sectionIndex === 0 ? 'レッスンを完了して次へ進む' : '次へ進む'}
          </Button>
        </div>
      </div>
    );
  }
}
